


























































import { Prop, Component, Mixins, Watch } from "vue-property-decorator";
import {
    calendarWeek,
    Day,
    getDay,
    shortDayNames,
    CARDINAL_NAMES,
    trunc,
    daysBetween,
    endOfDay,
} from "../../date-picker/private/Utils";
import CalendarMixin from "./CalendarMIxin";

@Component
export default class CalendarWeekView extends Mixins(CalendarMixin) {
    @Prop() isMondayFirst!: boolean;

    private weekCellHTML: HTMLElement | null = null;
    private cellHeight = 0;
    private resizeObserver: ResizeObserver | null = null;
    private timerId: number | null = null;

    async mounted() {
        await this.delay(100);
        this.addObserver();
    }
    destroyed() {
        this.resetObserver();
    }

    @Watch("week")
    private async onRowsUpdate(){
        await this.delay(100);
        this.resetObserver();
        this.addObserver();
    }

    private resetObserver() {
        if (this.timerId !== null) {
            clearInterval(this.timerId);
            this.timerId = null;
        } else if (this.resizeObserver !== null) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }
    private async addObserver() {
        await this.delay(100);
        const elements = this.$refs.weekcell_0 as HTMLElement[];
        this.weekCellHTML = elements && elements.length > 0 ? elements[0] : null;
        if (window.ResizeObserver && this.weekCellHTML) {
            this.resizeObserver = new ResizeObserver((/* elements */) => this.checkCellSize());
            this.resizeObserver.observe(this.weekCellHTML);
        } else {
            this.timerId = window.setInterval(() => this.checkCellSize(), 500);
        }
    }

    @Watch("cellHeight", {immediate: true})
    private onCellHeightUpdate(){
        this.$emit('cell-height-updated', this.cellHeight);
    }

    private checkCellSize() {
        this.cellHeight = this.weekCellHTML!.clientHeight;
    }

    private get dayHeaders(): string[] {
        return shortDayNames(this.isMondayFirst);
    }

    private get week(): Day[] {
        const week = calendarWeek(this.refDate, this.isMondayFirst);
        this.$emit("new-range", [trunc(week[0].dt), endOfDay(week[week.length - 1].dt)]);
        return week;
    }

    private get numWeek(): string {
        this.week[0].dt;
        const dt = this.week[0].dt;
        const firstDayOfMonth = new Date(dt.getFullYear(), dt.getMonth(), 1);
        const offset = Math.floor(firstDayOfMonth.getDay());
        let numWeek = Math.floor((dt.getDate() + offset) / 7);
        if (offset < 4) {
            numWeek++;
        }
        return CARDINAL_NAMES[numWeek - 1];
    }

    private get day() {
        return getDay(this.refDate, this.isMondayFirst);
    }

    private goToWeek(val: Date) {
        const days = daysBetween(this.refDate, val);
        this.navigate(days);
    }

    private async delay (ms: number) {
        new Promise(res => setTimeout(res, ms));
    }

}
